/**
 * A attempt in the business builder.
 * (representing an attempt to start a phase)
 */
export interface BusinessBuilderAttempt {
  readonly id: string;
  readonly createdAt: number;
  readonly userId?: number;
  readonly intendedPaymentAmount: number;
  readonly transactionId?: number;
  readonly phaseIndex: number;
  readonly projectCount: number;
  readonly phasesData: string;
  readonly workspaceId?: number;

  // These are only set when creating a workspace.
  readonly updateAction?: BusinessBuilderAttemptUpdateAction;
  readonly postImageId?: string;
  readonly workspaceUrl?: string;
}

export enum BusinessBuilderAttemptUpdateAction {
  TRANSACTION,
  WORKSPACE,
}
